import React, { useState } from "react";
import styles from "./SellerProvided.module.scss";
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { sellerProvidedTableData as initialData } from "../../../../../views/AdminPortal/dummyData";
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import Toggle from "../../../../common/AdminCommonComponents/Toggle/Toggle";

const sellerProvidedData = [
    { title: "Active free delivery offers", value: 0 },
    { title: "Pending approvals", value: 0 },
    { title: "Expired offers", value: 0 },
    { title: "Total Revenue Generated", value: 0 },
].map((item) => ({
    ...item,
    title: item.title.toUpperCase(),
}));

const SellerProvided = () => {
    const [tableData, setTableData] = useState(initialData);

    const handleToggleChange = (index) => {
        setTableData((prevData) =>
            prevData.map((item, i) =>
                i === index ? { ...item, toggleState: !item.toggleState } : item
            )
        );
    };

    const options = [
        { label: "View details" },
        { label: "Change Status" },
        { label: "Delete" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Offer ID",
            selector: (row) => row.offerId,
            center: "true",
            width: "120px",
        },
        {
            name: "Seller ID",
            selector: (row) => row.sellerId,
            center: "true",
            width: "120px",
        },
        {
            name: "Promotion Period",
            selector: (row) => row.promotionPeriod,
            center: "true",
            width: "200px",
        },
        {
            name: "Delivery Zone",
            selector: (row) => row.deliveryZone,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Applicability",
            selector: (row) => row.applicability,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Min. Order Value",
            selector: (row) => row.minOrderValue,
            center: "true",
            width: "180px",
        },
        {
            name: "Status",
            cell: (row) => <StatusBadge statusName={row.status} />,
            center: "true",
        },
        {
            name: "Status",
            cell: (row, index) => (
                <Toggle
                    theme="yellow"
                    checked={row.toggleState}
                    onChange={() => handleToggleChange(index)}
                />
            ),
            center: "true",
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.sellerProvidedContainer}>
            <div className={styles.overviewWrapper}>
                <h5 className={styles.mainHeading}>Free Delivery</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={sellerProvidedData} />
                </div>
            </div>

            <div className={styles.filterTableWrapper}>
                <h5 className={styles.sectionHeading}>Seller-provided Free Delivery</h5>
                <DynamicTableFilters
                    componentName={"Seller-provided Free Delivery"}
                    onApply={handleApply}
                    onClear={handleClear}
                />
                <div className={styles.tableWrapper}>
                    <DynamicDatatable
                        data={tableData}
                        columns={columns}
                        type="gray"
                        pagination
                        highlightOnHover
                        responsive
                    />
                </div>
            </div>
        </div>
    );
};

export default SellerProvided;